<template>
  <SAIUserProfile
    :fields="fields"
    :company-name="profile.companyName"
    :user-name="$auth.user.name"
    :editable="editable"
    :disable="savingUser"
    :saving="savingUser"
    :hide-editable-button="!canEditProfile"
    @update:input="update"
    @update:editable="editable = $event"
    @cancel="cancel"
    @save="save"
    @close="$emit('close')"
  />
</template>

<script>
import { SAIUserProfile, getUserProfileFields } from 'ecx.saigon.ui.common';
import { mapState, mapActions, mapGetters } from 'vuex';
import { INITIAL_USER } from '../../utils/constants';

export default {
  name: 'UserProfileWidget',
  data() {
    return {
      profile: { ...INITIAL_USER.profile },
      editable: false
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      savingUser: (state) => state.user.savingUser
    }),
    ...mapGetters('user', ['theme', 'canEditProfile']),
    ...mapGetters('application', ['creditCheckComplete']),
    fields() {
      const email = this.$auth.user.email;
      let fields = getUserProfileFields(
        {
          email,
          ...this.profile
        },
        email === this.user.profile.companyEmail,
        this.user.features.novatedPayrollCostCenterEmployee,
        this.creditCheckComplete
      );

      let contact = this.theme().novatedBrand?.support?.email;
      fields[0].values[0].locked = `Contact us at ${contact} to update your login email`;
      return fields;
    }
  },
  methods: {
    ...mapActions('user', ['saveUserProfile']),
    update({ key, value }) {
      this.profile = {
        ...this.profile,
        [key]: value || ''
      };
    },
    cancel() {
      this.resetProfile();
      this.editable = false;
    },
    async save() {
      await this.saveUserProfile(this.profile);
      this.editable = false;
      this.$emit('close');
    },
    resetProfile() {
      this.profile = this.user.profile || { ...INITIAL_USER.profile };
    }
  },
  mounted() {
    this.resetProfile();
  },
  components: {
    SAIUserProfile
  }
};
</script>
